module.exports = __webpack_public_path__ + "static/media/Pink_Button@3x.ed63bfd9.png";